module.exports = __webpack_public_path__ + "img/nxs.84b83a7b.svg";